export enum CareLinePriorityEnum
{
    Dengue = 'Dengue'
}